import { RagChip } from "@/components/ui/rag";

export function EvidenceFilteredList({ eyebrow, title, items, accent = "red", emptyLabel }) {
  const accentBar = accent === "red" ? "bg-destructive" : "bg-warning";
  return (
    <section className="paper-card overflow-hidden">
      <div className="flex items-center gap-3 border-b border-border bg-card/80 px-6 py-4">
        <span className={`block h-6 w-1 rounded-sm ${accentBar}`} />
        <div>
          <p className="eyebrow">{eyebrow}</p>
          <h3 className="font-display text-lg font-medium text-foreground">{title}</h3>
        </div>
        <span className="font-mono-label ml-auto text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
          {items.length} item{items.length === 1 ? "" : "s"}
        </span>
      </div>
      {items.length === 0 ? (
        <div className="px-6 py-8 text-sm text-muted-foreground">{emptyLabel}</div>
      ) : (
        <ul className="divide-y divide-border">
          {items.map((item) => (
            <li
              key={item.id}
              className="grid grid-cols-1 gap-2 px-6 py-4 md:grid-cols-12 md:items-start md:gap-4"
            >
              <div className="md:col-span-2">
                <span className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                  {String(item.number).padStart(2, "0")} · {item.domain}
                </span>
              </div>
              <div className="md:col-span-7">
                <p className="font-display text-[15px] font-medium leading-tight text-foreground">
                  {item.title}
                </p>
                <p className="mt-0.5 text-xs leading-relaxed text-muted-foreground">{item.helper}</p>
              </div>
              <div className="flex items-center gap-2 md:col-span-3 md:justify-end">
                <RagChip rag={item.rag}>{item.shortLabel}</RagChip>
              </div>
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
